<script>
import Constants from '../constants';

export default {
  methods: {
    // Use in filter method to keep only evaluable fiels in a template
    $filterDisplayCartographie(competence) {
      return competence.display_cartographie;
    },

    // Use in a filter method for MULTI2 template type.
    // Put a filter after template version (temp.data[0] with 0 is initial version).
    // Choose the libelles list
    $filterEvaluationIntitulesMulti2(data) {
      return data.libelle === 'Intitulés des évaluations';
    },

    // Use in a filter method for MULTI2 template type.
    // Put a filter after template version (temp.data[0] with 0 is initial version).
    // Choose the criterions list
    $filterCriterionsMulti2(data) {
      return data.libelle === "Critères d'évaluation";
    },

    $filterTemplateCompPerso(competence) {
      return (
        competence.template.page.module.name ===
        Constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES
      );
    },

    $filterTemplateCompSocio(competence) {
      return (
        competence.template.page.module.name ===
        Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
      );
    },

    $listCompetencesFilteredByTemplate(listTemplate) {
      let filter = [];
      listTemplate.forEach((template) => {
        switch (template.type) {
          case 'multi1':
            template.data[0].forEach((competence, competenceIndex) => {
              if (competence.display_cartographie)
                filter.push({
                  template: template,
                  domaine: null,
                  competence: competenceIndex,
                });
            });
            break;
          case 'multi2':
            break;
          case 'multi3':
            template.data[0].forEach((domaine, domaineIndex) => {
              domaine.forEach((competence, competenceIndex) => {
                if (competence.display_cartographie)
                  filter.push({
                    template: template,
                    domaine: domaineIndex,
                    competence: competenceIndex,
                  });
              });
            });
            break;

          default:
            break;
        }
      });
      return filter;
    },
  },
};
</script>
